<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>入金報告表</h1>
<form [formGroup]="outputCndtFormGroup" (ngSubmit)="download()">
  <app-sgke150d-condition *ngIf="codeMap" [codeMap]="codeMap"></app-sgke150d-condition>
</form>